import React from "react";
import { Nav } from "react-bootstrap";
import WizardNavItem from "components/wizard/WizardNavItem";
import {
    faFileAlt,
    faCheckCircle,
    faDatabase,
    faFlagCheckered
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

type Step = 1 | 2 | 3 | 4;

type Props = {
    activeStep: Step;
    canGoStep2: boolean; // mesma condição do "Avançar" do step 1 (ex: files.length > 0)
    canGoStep3: boolean; // mesma condição do "Avançar" do step 2 (ex: allValidated)
    canGoStep4: boolean; // mesma condição do "Avançar" do step 3 (ex: allImported)
};

export default function ImportWizardNav({
    activeStep,
    canGoStep2,
    canGoStep3,
    canGoStep4
}: Props) {
    const { t } = useTranslation();
    const tt = (key: string) => t(key, { ns: "translation" });
    const step1Completed = activeStep > 1 && canGoStep2;
    const step2Completed = activeStep > 2 && canGoStep3;
    const step3Completed = activeStep > 3 && canGoStep4;

    return (
        <Nav className="justify-content-between nav-wizard nav-wizard-success">
            <WizardNavItem
                icon={faFileAlt}
                step={1}
                label={tt("pages.thermography.dataImportWizard.nav.upload")}
                completed={step1Completed}
            />

            <WizardNavItem
                icon={faCheckCircle}
                step={2}
                label={tt("pages.thermography.dataImportWizard.nav.validation")}
                disabled={!canGoStep2}
                completed={step2Completed}
            />

            <WizardNavItem
                icon={faDatabase}
                step={3}
                label={tt("pages.thermography.dataImportWizard.nav.import")}
                disabled={!canGoStep3}
                completed={step3Completed}
            />

            <WizardNavItem
                icon={faFlagCheckered}
                step={4}
                label={tt("pages.thermography.dataImportWizard.nav.finish")}
                disabled={!canGoStep4}
            />
        </Nav>
    );
}
